export const News_DA = {
  news: {
    create_btn: "Opret ny artikel",
    desc: "Hold dig opdateret med seneste nyt fra",
    featured: "Fremhævede artikler",
    headline: {
      default: "Nyheder",
      mine: "Mine artikler",
      editorial: "Redaktionel artikler",
      popular: "Mest populære",
      community: "Artikler fra fællesskabet",
    },
    badges: {
      mine: "Mine",
      editorial: "Redaktionel",
      popular: "Mest populære",
      community: "Artikler fra fællesskabet",
    },
    actions: {
      copyUrl: "Kopier link til nyhed",
      copied: "Kopieret link til udklipsholder",
      copyFailed: "Kunne ikke kopiere link til udklipsholder",
    },
  },
};
